import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { arrayOf, bool, node, number, oneOf, oneOfType, string } from 'prop-types';
import { spacingPropType } from "../Box/propTypes";
import { ALIGN_ITEMS, ALIGN_SELF, DIRECTION, JUSTIFY_CONTENT } from "./constants";

var stringOrArrayOfStringsPropType = function stringOrArrayOfStringsPropType(constant) {
  var strings = Object.keys(constant);
  return oneOfType([oneOf(strings), arrayOf(oneOf(strings))]);
};

export var flexPropTypes = {
  alignItems: stringOrArrayOfStringsPropType(ALIGN_ITEMS),
  breakpoints: arrayOf(oneOfType([number, string])),
  children: node,
  direction: stringOrArrayOfStringsPropType(DIRECTION),
  gutterWidth: oneOfType([number, string]),
  minWidth: spacingPropType,
  justifyContent: stringOrArrayOfStringsPropType(JUSTIFY_CONTENT),
  wrap: oneOfType([bool, arrayOf(oneOfType([bool]))])
};
export var flexItemPropTypes = {
  alignSelf: stringOrArrayOfStringsPropType(ALIGN_SELF),
  breakpoints: arrayOf(oneOfType([number, string])),
  flex: bool,
  grow: oneOfType([number, arrayOf(number)]),
  shrink: oneOfType([number, arrayOf(number)])
};